import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { FiArchive, FiRotateCcw } from 'react-icons/fi'
import {
  Menu as MenuCha,
  MenuButton,
  MenuList,
  MenuItem,
  Icon,
  Button,
  useToast
} from '@chakra-ui/react'
import {
  EditIcon,
  CanceledIcon,
  OptionsIcons
} from '../../../components/Icons'
import {
  GetNotification,
  canManageProgramArchive,
  isLegacyArchivedProgram,
  isProgramArchived
} from '../../../Utils'
import {
  useArchiveProgram,
  useRestoreProgram
} from '../../../hooks/Programs'
import { CustomToast } from '../../../components/UI'
import { openResignationModal } from '../../../store/slices/modal'

const OptionsMenu = ({ program }) => {
  const { user } = useSelector((state) => state.auth)
  const dispatch = useDispatch()
  const history = useHistory()
  const toast = useToast()
  const { mutate: archiveProgram, isLoading: isArchiving } =
    useArchiveProgram()
  const { mutate: restoreProgram, isLoading: isRestoring } =
    useRestoreProgram()
  const isArchived = isProgramArchived(program)
  const isLoading = isArchiving || isRestoring

  const redirectProgramTypeDictionary = {
    HospitalAccommodation: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    SolidarityHealthFund: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    InjuredInLinesOfServiceKit: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    FireSupport: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    DisasterSupport: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    SupportInCaseOfDeathOfMember: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    NewbornBenefit: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    PreUniversityScholarships: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    TechnicalProfessionalScholarships: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    ScholarshipsApplicantOfficer: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    ScholarshipsApplicantOfficerDac: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    UniversityScholarships: () =>
      history.push(`/programs/edit/${program?._id}/${program?.type}`),
    WorkshopsAndTraining: () =>
      history.push(`/programs/edit-workshops-and-training/${program?._id}`)
  }

  const openResignationOrLossModal = () => {
    dispatch(openResignationModal())
  }

  const isDisableOptionResignationOrLoss = () => {
    const { state, steps } = program
    const isFinished = Boolean(
      state === 'COMPLETED-APPROVED' ||
        state === 'DELETED' ||
        state === 'COMPLETED-REJECTED' ||
        state === 'COMPLETED-REVOKED' ||
        state === 'REVOKED' ||
        state === 'REJECTED'
    )
    const hasActiveStepOne = Boolean(
      steps?.filter(
        (step) =>
          step?.key === 'RESIGNATION-OR-LOSS-AUTHORIZATION-RESIGNATION' &&
          !step?.complete
      ).length > 0
    )
    const hasActiveStepTwo = Boolean(
      steps?.filter(
        (step) => step?.key === 'CORRECT-REQUEST-RESIGNATION' && !step?.complete
      ).length > 0
    )
    // const hasActiveStepThree = Boolean(
    //   steps?.filter((step) => step?.key === 'END-PROCESS' && !step?.complete)
    //     .length > 0
    // )
    const hasActiveStepFour = Boolean(
      steps?.filter((step) => step?.key === 'FINISHED' && !step?.complete)
        .length > 0
    )

    if (
      isArchived ||
      isFinished ||
      hasActiveStepOne ||
      hasActiveStepTwo ||
      hasActiveStepFour
    ) {
      return true
    }
    return false
  }

  const getErrorMessage = (error, fallback) =>
    error?.response?.data?.message || fallback

  const mutateArchiveProgram = (reason) => {
    archiveProgram(
      { programId: program._id, reason },
      {
        onSuccess: () => {
          GetNotification.basic('Programa archivado con éxito', 'Aceptar')
          history.push('/programs')
        },
        onError: (err) => {
          GetNotification.basic(
            'Error',
            'Aceptar',
            getErrorMessage(err, 'No fue posible archivar el programa'),
            'error'
          )
        }
      }
    )
  }

  const questionArchiveProgram = () => {
    GetNotification.questionWithInput(
      '¿Archivar este programa?',
      mutateArchiveProgram,
      'El programa dejará de aparecer en los listados y reportes operativos.',
      'Motivo del archivado'
    )
  }

  const mutateRestoreProgram = () => {
    restoreProgram(program._id, {
      onSuccess: () => {
        GetNotification.basic('Programa restaurado con éxito', 'Aceptar')
        history.push('/programs')
      },
      onError: (err) => {
        GetNotification.basic(
          'Error',
          'Aceptar',
          getErrorMessage(err, 'No fue posible restaurar el programa'),
          'error'
        )
      }
    })
  }

  const questionRestoreProgram = () => {
    GetNotification.question(
      '¿Restaurar este programa?',
      mutateRestoreProgram,
      null,
      'Volverá a aparecer en los listados y reportes operativos.',
      'question'
    )
  }

  const getArchiveOptions = () => {
    if (!canManageProgramArchive(user)) return []

    if (isLegacyArchivedProgram(program)) {
      return [
        {
          text: 'Archivado histórico',
          icon: FiArchive,
          function: null,
          disabled: true
        }
      ]
    }

    if (isArchived) {
      return [
        {
          text: 'Restaurar',
          icon: FiRotateCcw,
          function: questionRestoreProgram,
          disabled: false
        }
      ]
    }

    return [
      {
        text: 'Archivar',
        icon: FiArchive,
        function: questionArchiveProgram,
        disabled: false
      }
    ]
  }

  const optionsMenu = [
    {
      text: 'Editar',
      icon: EditIcon,
      function: redirectProgramTypeDictionary[program?.type],
      disabled: Boolean(
        isArchived ||
        // program?.state === 'APPROVED' ||
          program?.state === 'COMPLETED-APPROVED' ||
          program?.state === 'DELETED' ||
          program?.state === 'COMPLETED-REJECTED' ||
          program?.state === 'REJECTED'
      )
    },
    {
      text: 'Renuncia o perdida',
      icon: CanceledIcon,
      function: () => openResignationOrLossModal(),
      disabled: isDisableOptionResignationOrLoss()
    },
    ...getArchiveOptions()
  ]

  useEffect(() => {
    if (isLoading) {
      toast({
        duration: 9000 * 9000,
        isClosable: true,
        position: 'bottom-right',
        render: ({ onClose: onCloseT }) => (
          <CustomToast
            text={'Espere por favor...'}
            status={'info'}
            onClose={onCloseT}
          />
        )
      })
      return
    }
    toast.closeAll()
  }, [isLoading, toast])

  return (
    <>
      {user.role !== 'REVISION' ? (
        <MenuCha isLazy>
          <MenuButton>
            <Icon fontSize="22" as={OptionsIcons} p={1} />
          </MenuButton>
          <MenuList
            borderRadius={20}
            py={3}
            px={3}
            color={'green.500'}
            zIndex={999999999}
          >
            {optionsMenu.map((item) => (
              <MenuItem key={item.text} p={0} _hover={{ bg: 'transparents' }}>
                <Button
                  w={'100%'}
                  bg={'transparent'}
                  justifyContent={'flex-start'}
                  borderRadius={20}
                  leftIcon={<Icon as={item.icon} />}
                  _hover={{ bg: 'green.50' }}
                  onClick={item?.function}
                  mb={1}
                  disabled={item.disabled}
                >
                  {item?.text}
                </Button>
              </MenuItem>
            ))}
          </MenuList>
        </MenuCha>
      ) : (
        <></>
      )}
    </>
  )
}

export default OptionsMenu
